import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { actions } from "./slice";
import * as API from "../../../../../services/apis";

export function* handleFetchOrders({ payload }) {
  try {
    const res = yield call(API.fetchOrderDetails, payload.id);
    const { data } = res;
    yield put(actions.fetchOrderDetailsSuccess(data));
    const orderId = data?.data?.document?.orderId;
    const orderStatus = data?.data?.document?.status?.value;
    if (
      orderStatus === "receivedAtLab" ||
      orderStatus === "underTesting" ||
      orderStatus === "reportUploaded" ||
      orderStatus === "completed" ||
      orderStatus === "underDispute"
    ) {
      payload.onSuccess(orderId);
    }
  } catch (err) {
    yield put(actions.fetchOrderDetailsFailure(err?.response?.data));
  }
}

export function* fetchSampleDetails({ payload }) {
  try {
    const res = yield call(API.fetchSampleDetailsForOrder, payload);
    const { data } = res;
    yield put(actions.fetchSampleDetailsSuccess(data));
  } catch (err) {
    yield put(actions.fetchSampleDetailsFailure(err?.response?.data));
  }
}

export function* handleFetchDropdown({ payload }) {
  try {
    const res = yield call(API.fetchDropdown, payload);
    const { data } = res;
    yield put(actions.fetchDropdownSuccess(data));
  } catch (err) {
    yield put(actions.fetchDropdownFailure(err?.response?.data));
  }
}

export function* handleSaveSampleReceivedDetails({ payload }) {
  try {
    // update sample received
    console.log("reached update sample receive saga");
    console.log(payload);
    if (payload.data.updateOrderStatus) {
      yield call(API.updateOrder, {
        id: payload.data.mongoDbOrderId,
        data: { status: payload.data.status },
      });
    }
    yield call(
      API.saveLabSampleResponseDetails,
      payload.data.labSampleReceivedDetails
    );

    if (payload.onSuccess) {
      payload.onSuccess();
    }
  } catch (err) {
    console.log(err.response.data);
    yield put(actions.saveSampleReceivedDetailsFailure(err?.response?.data));
    payload.onFailure();
  }
}

export function* handleSaveAcceptanceFormDetails({ payload }) {
  try {
    const res = yield call(API.saveAcceptanceFormData, payload);
    const { data } = res;
    yield put(actions.saveAcceptanceFormDetailsSuccess());

    const prevOrderStatus = payload?.orderStatus;
    const orderDetails = data?.data?.orderDetails;
    if (prevOrderStatus === "underDispute") {
      const requestCorrections =
        orderDetails?.underDispute?.at(-1)?.requestCorrections || [];

      const allCorrectionsResolved = requestCorrections?.every(
        (correction) => correction.isResolved === true
      );

      const hasReportCorrection = requestCorrections?.some(
        (correction) => correction.type === "report"
      );
      if (allCorrectionsResolved && hasReportCorrection) {
        // All corrections are resolved then call PDF parsing
        yield call(API.startPdfParsing, {
          order_id: orderDetails?.orderId,
        });
      }
    }

    payload.onSuccess(data?.data);
  } catch (err) {
    yield put(actions.saveAcceptanceFormDetailsFailure());
    payload.onFailure();
  }
}

export function* handleSaveLabellingFormDetails({ payload }) {
  try {
    const res = yield call(API.saveLabellingFormData, payload);
    const { data } = res;
    yield put(actions.saveLabellingFormDetailsSuccess());

    const prevOrderStatus = payload?.orderStatus;
    const orderDetails = data?.data?.orderDetails;
    if (prevOrderStatus === "underDispute") {
      const requestCorrections =
        orderDetails?.underDispute?.at(-1)?.requestCorrections || [];

      const allCorrectionsResolved = requestCorrections?.every(
        (correction) => correction.isResolved === true
      );
      
      const hasReportCorrection = requestCorrections?.some(
        (correction) => correction.type === "report"
      );
      if (allCorrectionsResolved && hasReportCorrection) {
        // All corrections are resolved then call PDF parsing
        yield call(API.startPdfParsing, {
          order_id: orderDetails?.orderId,
        });
      }
    }

    payload.onSuccess(data?.data);
  } catch (err) {
    yield put(actions.saveLabellingFormDetailsFailure());
    payload.onFailure();
  }
}

export function* handleMoveToUnderTesting({ payload }) {
  try {
    const res = yield call(API.updateOrderStatus, payload);
    yield put(actions.moveToUnderTestingSuccess(res.data));
    payload?.onSuccess();
  } catch (err) {
    yield put(actions.moveToUnderTestingFailure(err?.response?.data));
    payload.onFailure(err?.response?.data?.document);
  }
}

/**
 * Root saga manages watcher lifecycle
 */
export function* saveSampleReceivedDetailsSaga() {
  yield takeLatest(actions.fetchOrderDetails.type, handleFetchOrders);
  yield takeLatest(actions.fetchDropdown.type, handleFetchDropdown);
  yield takeLatest(actions.fetchSampleDetails.type, fetchSampleDetails);
  yield takeEvery(
    actions.saveSampleReceivedDetails.type,
    handleSaveSampleReceivedDetails
  );
  yield takeEvery(
    actions.saveAcceptanceFormDetails.type,
    handleSaveAcceptanceFormDetails
  );
  yield takeEvery(
    actions.saveLabellingFormDetails.type,
    handleSaveLabellingFormDetails
  );
  yield takeEvery(actions.moveToUnderTesting.type, handleMoveToUnderTesting);
}
